var _excluded = ["vertical", "size", "weight", "dividerColor", "textAlignment", "labelPadding", "textColor", "textWeight", "labelBackground", "label", "textFontSize", "labelBackgroundPadding", "textPositionPadding", "altFont"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames';
import React from 'react';
import styles from './styles.module.scss';
import Text from '../text/component';

var Divider = function Divider(_ref) {
  var _classnames;

  var vertical = _ref.vertical,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '' : _ref$size,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? '' : _ref$weight,
      _ref$dividerColor = _ref.dividerColor,
      dividerColor = _ref$dividerColor === void 0 ? '' : _ref$dividerColor,
      _ref$textAlignment = _ref.textAlignment,
      textAlignment = _ref$textAlignment === void 0 ? 'center-horizontal' : _ref$textAlignment,
      _ref$labelPadding = _ref.labelPadding,
      labelPadding = _ref$labelPadding === void 0 ? '' : _ref$labelPadding,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? '' : _ref$textColor,
      textWeight = _ref.textWeight,
      _ref$labelBackground = _ref.labelBackground,
      labelBackground = _ref$labelBackground === void 0 ? 'regular-background' : _ref$labelBackground,
      label = _ref.label,
      textFontSize = _ref.textFontSize,
      _ref$labelBackgroundP = _ref.labelBackgroundPadding,
      labelBackgroundPadding = _ref$labelBackgroundP === void 0 ? '' : _ref$labelBackgroundP,
      _ref$textPositionPadd = _ref.textPositionPadding,
      textPositionPadding = _ref$textPositionPadd === void 0 ? '' : _ref$textPositionPadd,
      altFont = _ref.altFont,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    "data-testid": "divider",
    className: classnames(styles.divider, styles[size], styles[weight], styles[dividerColor], styles[textAlignment], styles[textColor], (_classnames = {}, _defineProperty(_classnames, styles.vertical, vertical), _defineProperty(_classnames, styles.horizontal, !vertical), _classnames))
  }, props), !!label && /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.textstyle, styles[labelPadding], styles[labelBackground], styles[labelBackgroundPadding], styles[textPositionPadding])
  }, /*#__PURE__*/React.createElement(Text, {
    altFont: altFont,
    weight: textWeight,
    size: textFontSize
  }, label))));
};

export default Divider;